import type { HttpClient } from '@/utils/HttpClient';
import { Stock } from '@/types';

export type StockService = {
  fetchStock: (articles: { articleNumber: string; quantity: number }[], locationIds: string[]) => Promise<unknown>;
};

export const StockService = (httpClient: HttpClient): StockService => ({
  fetchStock(articles, locationIds) {
    const body = {
      articles,
      ...(locationIds?.length && { locationIds }),
    };

    return httpClient<Stock[]>({ endpoint: '/stock', method: 'POST', body });
  },
});
